import React, { ReactElement } from "react";
import useStyles from './styles';
import yassirLogo from '../../assets/images/logo_brand_web.svg';

const YassirLoader: React.FC = (): ReactElement => {
    const classes = useStyles();
    return (
        <>
            <div className={classes.loadingDiv}>
                <img className={classes.yassirLogo} src={yassirLogo} alt=""/>
            </div>
        </>
    )
}

export default YassirLoader;